import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import MainLayout from './components/layout/MainLayout';
import StudyBuilder from './components/StudyBuilder/StudyBuilder';
import MetadataExplorer from './components/MetadataExplorer/MetadataExplorer';
import InsightConsole from './components/InsightConsole/InsightConsole';
import InsightGenerator from './components/InsightGenerator/InsightGenerator';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#722ed1', // Purple theme matching NRG Refract
          borderRadius: 6,
          fontSize: 14,
        },
      }}
    >
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/study-builder" element={<StudyBuilder />} />
            <Route path="/study-builder/:studyId" element={<StudyBuilder />} />
            <Route path="/metadata-explorer/:studyId" element={<MetadataExplorer />} />
            <Route path="/insight-console/:studyId" element={<InsightConsole />} />
            <Route path="/insight-generator/:studyId" element={<InsightGenerator />} />
          </Routes>
        </MainLayout>
      </Router>
    </ConfigProvider>
  );
};

export default App; 